import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus, Phone } from "lucide-react";
import { FAQS, COMPANY } from "@/data/content";

export default function FAQ({ items = FAQS, title = "Roofing Questions, Answered", eyebrow = "Common Questions" }) {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="py-24 bg-obsidian">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-14">
          <p className="text-xs uppercase tracking-[0.2em] text-honey font-bold mb-3">{eyebrow}</p>
          <h2 className="text-4xl sm:text-5xl font-display font-black uppercase tracking-tighter text-white">
            {title}
          </h2>
        </div>

        <div className="space-y-3">
          {items.map((f, i) => (
            <div key={i} data-testid={`faq-item-${i}`}
              className="border border-white/10 rounded-sm bg-carbon overflow-hidden">
              <button onClick={() => setOpen(open === i ? -1 : i)}
                data-testid={`faq-toggle-${i}`}
                className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 hover:bg-white/[0.03] transition-colors">
                <span className="text-base font-semibold text-white">{f.q}</span>
                {open === i ? <Minus className="w-5 h-5 text-honey shrink-0" /> : <Plus className="w-5 h-5 text-honey shrink-0" />}
              </button>
              <AnimatePresence>
                {open === i && (
                  <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
                    className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm text-zinc-400 leading-relaxed">{f.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-zinc-400">Still have questions? Talk to a real local roofer.</p>
          <a href={`tel:${COMPANY.phoneRaw}`} data-testid="faq-call-link"
            className="mt-3 inline-flex items-center gap-2 text-honey font-bold text-lg hover:gap-3 transition-all">
            <Phone className="w-5 h-5" /> {COMPANY.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
